import { Badge } from "@/components/ui";
import { cn } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { useGetOccupancyListByCommunity } from "@/services";
import moment from "moment";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const useUsersList = () => {
  const [globalFilter, setGlobalFilter] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: communityUsers, isLoading: isLoadingCommunityUsers } =
    useGetOccupancyListByCommunity({
      communityId: id as string,
      queryParams: {
        enabled: !!id,
      },
    });

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const breadcrumbData = [
    {
      link: `/${routes.cam}/${routes.communities}`,
      name: `Community - ${communityDetail?.name || ""}`,
    },
    {
      link: "",
      name: <span className="text-primary">Users List</span>,
    },
  ];

  const columns = [
    {
      accessorKey: "occupancyId",
      header: "Ownership ID",
    },
    {
      accessorKey: "userName",
      header: "User ID",
    },
    {
      accessorKey: "firstName",
      header: "First Name",
    },
    {
      accessorKey: "lastName",
      header: "Last Name",
    },
    {
      accessorKey: "propertyName",
      header: "Property Name",
    },
    {
      accessorKey: "occupancyType",
      header: "Occupant Type",
    },
    {
      accessorKey: "startDate",
      header: "Start Date",
      cell: (row: any) => {
        return row.row.original.startDate
          ? moment(row.row.original.startDate).format("MM/DD/YYYY")
          : "";
      },
    },
    {
      accessorKey: "endDate",
      header: "End Date",
      cell: (row: any) => {
        return row.row.original.endDate
          ? moment(row.row.original.endDate).format("MM/DD/YYYY")
          : "";
      },
    },
    {
      accessorKey: "status",
      header: (
        <div className="flex items-center w-[80px] justify-center gap-2">
          Status
        </div>
      ),
      cell: (row: any) => {
        return (
          <Badge
            variant="outline"
            className={cn(
              row.row.original.endDate
                ? "border-red-600 bg-red-100 text-red-600"
                : "border-green-600 bg-green-100 text-green-600",
              "rounded-full px-4 py-2"
            )}
          >
            {row.row.original.endDate ? "Inactive" : "Active"}
          </Badge>
        );
      },
    },
    {
      accessorKey: "mobileNo",
      header: "Mobile No.",
    },
  ];

  const onBackClick = () => {
    navigate(`/${routes.cam}/${routes.communities}`);
  };

  return {
    columns,
    globalFilter,
    setGlobalFilter,
    isLoadingCommunityUsers,
    communityUsers,
    breadcrumbData,
    onBackClick,
    communityDetail,
  };
};

export default useUsersList;
